// SH-5: session registry + device trust client bindings.
import { supabase } from "@/integrations/supabase/client";
import { deviceFingerprint } from "@/lib/stepup";

async function hash(value: string): Promise<string> {
  const buf = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(value));
  return Array.from(new Uint8Array(buf)).map(b => b.toString(16).padStart(2, "0")).join("");
}

/** Registers/refreshes the security session record for the signed-in session. */
export async function registerSecuritySession(): Promise<void> {
  try {
    await supabase.rpc("register_security_session", {
      _user_agent_hash: await hash(navigator.userAgent),
      _device_fingerprint: deviceFingerprint(),
      _platform: navigator.platform || null,
      _label: null,
    });
  } catch {
    // Never block sign-in on telemetry; the server still enforces authority.
  }
}
